'use client'

import { type CSSProperties, type ReactNode } from 'react'

import { cn, createSlot } from '@/shared/lib'

type Props = {
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export const MobileHeader = ({ className, style, children }: Props) => {
  const { slots } = createSlot(children, ['left', 'title', 'right', 'children'])

  return (
    <header
      className={cn(
        'relative flex h-14 items-center justify-center bg-white p-4',
        className,
      )}
      style={style}
    >
      {slots.left && (
        <div className="absolute top-4 left-4 flex gap-3">{slots.left}</div>
      )}
      {slots.title && (
        <h1 className="typo-body1 max-w-[calc(100vw-168px)] truncate font-medium text-black">
          {slots.title}
        </h1>
      )}
      {slots.right && (
        <div className="absolute top-4 right-4 flex gap-3">{slots.right}</div>
      )}
      {slots.children}
    </header>
  )
}
